import { AnyAction } from 'redux';
import {
  VIEW_MGMT_FETCH_MASTERDATA_SUCCESS,
  VIEW_MGMT_FETCH_PREFERENCE_SUCCESS,
  VIEW_MGMT_SET_FILTER_LIST,
  VIEW_MGMT_SET_LOADING,
} from './ViewManagement.constants';
import {
  IViewManagementByPageType,
  IViewManagementState,
} from './ViewManagement.types';

const defaultPageState: IViewManagementByPageType = {
  savedViews: [],
  customView: null,
  userViewState: {
    linkedViewId: null,
    linkedViewName: null,
    isUsingOrgDefault: false,
  },
  fullMetadata: null,
  resolvedPreference: null,
};

const defaultState: IViewManagementState = {
  loading: {
    fetchMasterdata: false,
    fetchPreference: false,
  },
};

const getPageState = (
  state: IViewManagementState,
  pageType: string,
): IViewManagementByPageType => {
  return (state[pageType] as IViewManagementByPageType) || defaultPageState;
};

export default function viewManagementReducer(
  state: IViewManagementState = defaultState,
  action: AnyAction,
): IViewManagementState {
  switch (action.type) {
    case VIEW_MGMT_SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.key]: action.value,
        },
      };

    case VIEW_MGMT_FETCH_MASTERDATA_SUCCESS: {
      const { pageType, savedViews, customView, fullMetadata } = action;
      const current = getPageState(state, pageType);
      return {
        ...state,
        [pageType]: {
          ...current,
          savedViews,
          customView,
          fullMetadata,
        },
      };
    }

    case VIEW_MGMT_FETCH_PREFERENCE_SUCCESS: {
      const { pageType, userViewState, resolvedPreference } = action;
      const current = getPageState(state, pageType);
      return {
        ...state,
        [pageType]: {
          ...current,
          userViewState,
          resolvedPreference,
        },
      };
    }

    case VIEW_MGMT_SET_FILTER_LIST: {
      const { pageType, bucket, filterList } = action;
      const current = getPageState(state, pageType);
      if (!current.resolvedPreference) {
        return state;
      }
      return {
        ...state,
        [pageType]: {
          ...current,
          resolvedPreference: {
            ...current.resolvedPreference,
            filterListByBucket: {
              ...current.resolvedPreference.filterListByBucket,
              [bucket]: filterList,
            },
          },
        },
      };
    }

    default:
      return state;
  }
}
